import React from 'react';
import { observer } from 'mobx-react';
import { VendorsListTemplate } from 'themes/application/vendors/pages';
import { setCurrentView } from 'core/utils';
import { VendorsListViewStore } from 'application/vendors/stores';

@setCurrentView((rootStore) => new VendorsListViewStore(rootStore), 'vendorsListViewStore')
@observer
class VendorsList extends React.Component {
    render() {
        return <VendorsListTemplate {...this.props} />
    }
}

export default VendorsList;